import React, { useEffect, useMemo, useState } from "react";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import z from "zod";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

import { useDispatch, useSelector } from "react-redux";
// import useUserAccess from "../useUserAccess";
// import apiService from "../../../services/service";
// import API_ROUTES from "../../../api-routes";
// import Notification from "../../../components/entities/notification/Notification";
import { useForm, Controller } from "react-hook-form";
import AdminOnly from "~/components/AdminOnly";
import CustomeButton from "~/components/Button";
// import { getWorkOsUserById } from "~/components/settings/users/invite-modal/InviteModalSlice";
import useUserAccess from "~/Pages/UserAccess/useUserAccess";
import apiService from "~/services/service";
import Notification from "~/components/entities/notification/Notification";
import { getWorkOsUserById } from "~/components/settings/users/invite-modal/InviteModalSlice";
import API_ROUTES_V2 from "~/api-routes-v2";

const TenantUserInfo = () => {
  const { userId: id, id: tenantId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { states, handleAssignLsp } = useUserAccess(id);
  const { isAdmin } = useSelector((state) => state.login);
  const [role, setRole] = useState("");
  const [selectedLsp, setSelectedLsp] = useState(states?.userlsp?.id ?? null);
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const userdata = useMemo(
    () => ({
      ...states?.workosuser,
      first_name: states?.workosuser?.first_name,
      last_name: states?.workosuser?.last_name,
      other_name: states?.workosuser?.other_name || "",
      preferred_name: states?.workosuser?.preferred_name || "",
    }),
    [states?.workosuser],
  );
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      first_name: states?.workosuser?.first_name || "",
      other_name: states?.workosuser?.other_name || "",
      last_name: states?.workosuser?.last_name || "",
      preferred_name: states?.workosuser?.preferred_name || "",
    },
  });
  const initialdata = () => {
    let obj = {
      first_name: userdata?.first_name || "",
      other_name: userdata?.other_name ? userdata?.other_name : "",
      last_name: userdata?.last_name || "",
      preferred_name: userdata?.preferred_name || "",
    };
    return obj;
  };
  useEffect(() => {
    const obj = initialdata();
    setUserInfo(userdata);
  }, [userdata]);

  const handleChange = (name, value) => {
    setUserInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (
      (userdata?.first_name === userInfo?.first_name &&
        userdata?.other_name === userInfo?.other_name &&
        userdata?.last_name === userInfo?.last_name &&
        userdata?.role === userInfo?.role &&
        (userdata?.lspid ?? null) === (selectedLsp?.id ?? null) &&
        userdata?.preferred_name === userInfo?.preferred_name) ||
      !userInfo?.first_name?.length
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [userInfo, selectedLsp]);

  //   useEffect(()=>{
  //     setUserLocalTeam(states?.userlsp)
  //   },[states?.userlsp])

  const handleUpdateUserInformation = async () => {
    try {
      setLoading(true);
      await apiService(API_ROUTES_V2.UPDATE_USER, "PUT", {
        body: {
          first_name: userInfo?.first_name || "",
          last_name: userInfo?.last_name || "",
          other_name: userInfo?.other_name || "",
          preferred_name: userInfo?.preferred_name || "",
          role,
        },
        replace: { id },
        schema: z.object({
          id: z.string().uuid(),
          first_name: z.string().optional(),
          last_name: z.string().optional(),
          other_name: z.string().optional(),
          preferred_name: z.string().optional(),
          role: z.enum([
            "CUSTOMER",
            "LSP_USER",
            "GXM_ADMIN",
            "GXM_USER",
            "GXM_MANAGER",
            "LSP_MANAGER",
            "CUSTOMER_MANAGER",
          ]),
        }),
      });
      dispatch(getWorkOsUserById(id));
      setIsEditing(false);
      const original = userdata?.lspid ?? null;
      const current = selectedLsp ?? null;

      if (original != current?.id) {
        handleAssignLsp({ target: { value: selectedLsp } });
      }
      setSuccessMessage("User updated successfully");

      // GXM-1783: Navigate back with skipCache flag to refresh Assigned Users list
      setTimeout(() => {
        navigate(`/tenants/${tenantId}/users`, {
          state: { refetchUsers: true },
          replace: false,
        });
      }, 1500);
    } catch (error) {
      console.log(error);
      setMessage("Something went wrong, please try again later");
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (e) => {
    setRole("");
    try {
      await apiService(API_ROUTES_V2.UPDATE_USER, "PUT", {
        body: {
          first_name: userInfo?.first_name || "",
          last_name: userInfo?.last_name || "",
          other_name: userInfo?.other_name || "",
          preferred_name: userInfo?.preferred_name || "",
          role: e.value,
        },
        replace: { id },
        schema: z.object({
          id: z.string().uuid(),
          first_name: z.string().optional(),
          last_name: z.string().optional(),
          other_name: z.string().optional(),
          preferred_name: z.string().optional(),
          role: z.enum([
            "CUSTOMER",
            "LSP_USER",
            "GXM_ADMIN",
            "GXM_USER",
            "GXM_MANAGER",
            "LSP_MANAGER",
            "CUSTOMER_MANAGER",
          ]),
        }),
      });
      setRole(e.value);
      setSuccessMessage("User role updated successfully");
    } catch (error) {
      console.log(error);
      setMessage("Something went wrong, please try again later");
      setRole(states?.workosuser?.role);
    }
  };
  const handleDiscard = () => {
    const data = initialdata();
    setUserInfo(data);
    setIsEditing(false);
  };

  useEffect(() => {
    if (states?.workosuser?.role) setRole(states?.workosuser?.role);
  }, [states?.workosuser]);

  return (
    <>
      <Card className="gen-card h-full">
        <div className="flex justify-content-between formgrid grid grid-nogutter w-full">
          <div className="flex justify-content-between align-items-center w-full">
            <div>
              <p className="profile-heading">User Information</p>
              <p className="profile-para">
                Find all the relevant information related to your profile
              </p>
            </div>
            <AdminOnly>
              {isEditing ? (
                <div className="flex gap-2">
                  <CustomeButton
                    label={"Discard"}
                    className={`mr-2`}
                    onClick={() => {
                      handleDiscard();
                    }}
                  />
                  <CustomeButton
                    label={"Save"}
                    className={`mr-2 ${disabled ? "disable_btn" : null}`}
                    variant="contained"
                    onClick={() => {
                      handleUpdateUserInformation();
                    }}
                    disabled={disabled}
                    icon="pi pi-pencil"
                    iconPos="right"
                    loading={loading}
                  />
                </div>
              ) : (
                <CustomeButton
                  label={"Edit"}
                  className="mr-2"
                  variant="contained"
                  onClick={() => {
                    setIsEditing(!isEditing);
                  }}
                  icon="pi pi-pencil"
                  iconPos="right"
                />
              )}
            </AdminOnly>
          </div>
          <Notification
            message={message}
            successMessage={successMessage}
            setMessage={setMessage}
            setSuccessMessage={setSuccessMessage}
          />
          <div className="formgrid grid mt-2 w-full">
            <div className="field col-12 md:col-6 mb-0">
              <label className="input-label">
                Given Name(s) *{" "}
                <i className="pi pi-info-circle" id="given-name-info"></i>
                <Tooltip
                  target="#given-name-info"
                  content="This is usually the person's first name or the name they usually go by."
                  position="right"
                  className="custom-tooltip tooltip-custom-format"
                />
              </label>

              <Controller
                name="first_name"
                control={control}
                rules={{ required: "Given name is required." }}
                render={({ field }) =>
                  states?.loadingData ? (
                    <Skeleton
                      data-testid="skeleton-loader"
                      className="p-4"
                    ></Skeleton>
                  ) : (
                    <InputText
                      value={userInfo?.first_name || ""}
                      placeholder="Given Name"
                      name="first_name"
                      type="text"
                      onChange={(e) => {
                        handleChange("first_name", e.target.value);
                        field.onChange(e);
                      }}
                      disabled={!isEditing}
                      className={`appearance-none outline-none w-full ${
                        errors.first_name ? "p-invalid" : ""
                      } ${!isEditing ? "disabled-input" : ""}`}
                    />
                  )
                }
              />
              {errors.first_name && (
                <small className="p-error">{errors.first_name.message}</small>
              )}
            </div>

            <div className="field col-12 md:col-6 mb-0">
              <label className="input-label">
                Other Name(s)
                <i
                  className="ml-2 pi pi-info-circle info-icon"
                  id="other-name-info"
                ></i>
                <Tooltip
                  target="#other-name-info"
                  content="Any middle or extra names that the employee has. You can leave this blank if it doesn’t apply."
                  position="right"
                  className="custom-tooltip tooltip-custom-format"
                />
              </label>
              <Controller
                name="other_name"
                control={control}
                render={({ field }) =>
                  states?.loadingData ? (
                    <Skeleton data-testid="skeleton-loader" className="p-4" />
                  ) : (
                    <InputText
                      value={userInfo?.other_name || ""}
                      placeholder="Other Name"
                      name="other_name"
                      type="text"
                      onChange={(e) => {
                        handleChange("other_name", e.target.value);
                        field.onChange(e);
                      }}
                      disabled={!isEditing}
                      className={`appearance-none outline-none w-full ${
                        !isEditing ? "disabled-input" : ""
                      }`}
                    />
                  )
                }
              />
            </div>

            <div className="field col-12 md:col-12 mb-0 mt-3">
              <label className="input-label">
                Surname(s)
                <i
                  className="ml-2 pi pi-info-circle info-icon"
                  id="sur-name-info"
                ></i>
                <Tooltip
                  target="#sur-name-info"
                  content="This is usually a family name or last name. If employee has more than one, include them here."
                  position="right"
                  className="custom-tooltip tooltip-custom-format"
                />
              </label>
              <Controller
                name="last_name"
                control={control}
                render={({ field }) =>
                  states?.loadingData ? (
                    <Skeleton data-testid="skeleton-loader" className="p-4" />
                  ) : (
                    <InputText
                      value={userInfo?.last_name || ""}
                      placeholder="Enter Surname(s)"
                      name="last_name"
                      type="text"
                      onChange={(e) => {
                        handleChange("last_name", e.target.value);
                        field.onChange(e);
                      }}
                      disabled={!isEditing}
                      className={`appearance-none outline-none w-full ${
                        !isEditing ? "disabled-input" : ""
                      }`}
                    />
                  )
                }
              />
            </div>

            <div className="field col-12 md:col-12 mb-0 mt-3">
              <label className="input-label">
                Preferred name(s)
                <i
                  className="ml-2 pi pi-info-circle info-icon"
                  id="preffered-name-info"
                ></i>
                <Tooltip
                  target="#preffered-name-info"
                  content="If the employee wants to be called by a different name than their given name, put that here."
                  position="right"
                  className="custom-tooltip tooltip-custom-format"
                />
              </label>
              <Controller
                name="preferred_name"
                control={control}
                render={({ field }) =>
                  states?.loadingData ? (
                    <Skeleton data-testid="skeleton-loader" className="p-4" />
                  ) : (
                    <InputText
                      value={userInfo?.preferred_name || ""}
                      placeholder="Preferred Name or Nickname"
                      name="preferred_name"
                      type="text"
                      onChange={(e) => {
                        handleChange("preferred_name", e.target.value);
                        field.onChange(e);
                      }}
                      disabled={!isEditing}
                      className={`appearance-none outline-none w-full ${
                        !isEditing ? "disabled-input" : ""
                      }`}
                    />
                  )
                }
              />
            </div>

            <div className="field lg:col-6 md:col-6 sm:col-12 xs:col-12 mb-0 mt-3">
              <label className="input-label">Email</label>
              {states?.loadingData ? (
                <Skeleton
                  data-testid="skeleton-loader"
                  className="p-4"
                ></Skeleton>
              ) : (
                <div className="icon-field">
                  <InputText
                    value={states?.workosuser?.email}
                    placeholder="evaccaro@company.com"
                    name="email"
                    type="text"
                    disabled
                    className="appearance-none outline-none w-full disabled-input"
                  />
                  <i className="pi pi-lock input-icon" />
                </div>
              )}
            </div>
            <div className="field lg:col-6 md:col-6 sm:col-12 xs:col-12 mb-0 mt-3">
              <label className="input-label">User role</label>
              {states?.loadingData ? (
                <Skeleton
                  data-testid="skeleton-loader"
                  className="p-4"
                ></Skeleton>
              ) : (
                <Dropdown
                  options={[
                    { label: "GXM Admin User", value: "GXM_ADMIN" },
                    { label: "GXM User", value: "GXM_USER" },
                    { label: "GXM Manager", value: "GXM_MANAGER" },
                    { label: "Local Team User", value: "LSP_USER" },
                    { label: "Local Team Manager", value: "LSP_MANAGER" },
                    { label: "Customer Manager", value: "CUSTOMER_MANAGER" },
                    { label: "Customer User", value: "CUSTOMER" },
                  ]}
                  loading={!role}
                  value={role}
                  className={`w-full p-0 ${!isEditing ? "disabled-input" : ""}`}
                  placeholder={!role ? "Loading..." : "Role"}
                  onChange={(e) => {
                    setRole(e.value);
                    handleChange("role", e.target.value);
                  }}
                  disabled={!isEditing}
                />
              )}
            </div>

            {["LSP_USER", "LSP_MANAGER"]?.includes(
              states?.workosuser?.role,
            ) && (
              <div className="field lg:col-6 md:col-6 sm:col-12 xs:col-12 mb-0 mt-2">
                <div className="mb-2">
                  <label className="input-label ">Local Team</label>
                </div>

                {states?.entitylistLoading ? (
                  <Skeleton
                    data-testid="skeleton-loader"
                    className="p-4"
                  ></Skeleton>
                ) : (
                  <Dropdown
                    // value={states?.userlsp || {}}
                    value={selectedLsp}
                    onChange={(e) => {
                      if (!isAdmin) {
                        return null;
                      }
                      setSelectedLsp(e.value);
                    }}
                    loading={states?.entitylistLoading}
                    options={states?.lspList}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Local Team"
                    className={`w-full p-0 ${
                      !isEditing ? "disabled-input" : ""
                    }`}
                    disabled={!isEditing}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    </>
  );
};
export default TenantUserInfo;
